module.exports = __webpack_public_path__ + "static/media/advait.394f6320.jpeg";